import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SmtpConfig } from '../../models/smtp-config.model';


@Component({
    selector: 'app-settings-smtp-table',
    standalone: true,
    imports: [
        MatTableModule
    ],
    templateUrl: './settings-smtp-table.component.html',
    styleUrl: './settings-smtp-table.component.css'
})
export class SettingsSmtpTableComponent implements OnInit {

  //public accounts: SmtpConfig[] = [];
  @Input() accounts: SmtpConfig[] = [];

  public dataSource = new MatTableDataSource<any>(this.accounts);

  public displayedColumns: string[] = [
    'host', 
    'port', 
    'start_tls_enable', 
    'auth', 
    'username', 
    'password', 
    'account_type'
  ];

  ngOnInit(): void {
      this.dataSource = new MatTableDataSource<any>(this.accounts);
      console.log("ngOnInit", this.accounts)
  }


}
